import i18n from "@/plugins/i18n"

export const PROCEDURE_ACCESS_TYPE = {
    TYPE_OPEN: i18n.global.t('Открытая'),
    TYPE_CLOSED: i18n.global.t('Закрытая'),
};

export const PROCEDURE_TYPE = {
    ProposalsRequest: 'proposalsRequest',
}

export const PROCEDURE_ROUND = {
    Basic: 'basic',
}

export const PROCEDURE_STEP = {
    Published: 'published',
    Review: 'review',
    Summing: 'summing',
    Agreement: 'agreement',
    Archived: 'archived',
    Canceled: 'canceled',
    Completed: 'completed',
}
